// Excerpt from the color palette used in MLflow UI, intended to be used in the MLflow experiment runs.
// The color values are copied instead of used from theme directly.
export const RUNS_COLOR_PALETTE = [
  // Secondary colors:
  '#a6630c', // Brown
  '#c83243', // Coral
  '#b45091', // Pink
  '#8a63bf', // Purple
  '#434a93', // Indigo
  '#137dae', // Turquoise
  '#04867d', // Teal
  '#308613', // Lime
  '#facb66', // Lemon

  // Colors list, intensities 700-400:
  '#1f272d', // Grey 700
  '#445461', // Grey 600
  '#5f7281', // Grey 500
  '#8396a5', // Grey 400

  '#93320b', // Yellow 700
  '#be501e', // Yellow 600
  '#de7921', // Yellow 500
  '#f2be88', // Yellow 400

  '#115026', // Green 700
  '#277c43', // Green 600
  '#3caa60', // Green 500
  '#8ddda8', // Green 400

  '#9e102c', // Red 700
  '#c82d4c', // Red 600
  '#e65b77', // Red 500
  '#f792a6', // Red 400

  '#0e538b', // Blue 700
  '#2272b4', // Blue 600
  '#4299e0', // Blue 500
  '#8acaff', // Blue 400
];

export const RUNS_COLOR_PALETTE_NEXT = [
  '#5387dd',
  '#da4c4c',
  '#479a5f',
  '#7d54b2',
  '#e87b9f',
  '#e57439',
  '#87cebf',
  '#c565c7',
  '#edb732',
  '#5bc5db',
  '#229487',
  '#f0b899',
  '#a0c75c',
  '#a46750',
  '#a1a9ad',
];
